import { render, staticRenderFns } from "./compayInfo.vue?vue&type=template&id=42f20a94&scoped=true&"
import script from "./compayInfo.vue?vue&type=script&lang=js&"
export * from "./compayInfo.vue?vue&type=script&lang=js&"
import style0 from "./compayInfo.vue?vue&type=style&index=0&id=42f20a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f20a94",
  null
  
)

export default component.exports